const Faqs = {
    data() {
        return {
            faqs: [],
            faqsFound: null
        }
    },
    mounted() {
        try {
            this.faqsFound = setInterval(() => {
                if(document.getElementById('faqs')) {
                    clearInterval(this.faqsFound);
                    setTimeout(() => {
                        this.faqs = JSON.parse(document.getElementById('faqs').textContent);
                    }, 50);
                }
            },1000);
        } catch (e) {
            console.error(e)
        }
    },
    template: `<div class="faqs-wrapper" v-if="faqs.length > 0">
      <dl class="faq-tab">
        <template v-for="(faq, index) in faqs" :key="index">
          <dt role="button" :class="{'collapsed':faq.collapsed}" @click.prevent="faq.collapsed = !faq.collapsed">{{faq.q}}</dt>
          <dd class="collapse" :class="{'in':!faq.collapsed}">
            <div class="contents" v-html="faq.a"></div>
          </dd>
      </template>
    </dl>
  </div>`
}
const AdditionalInfo = {
    props: {
        item: Object
    },
    data() {
        return {

        }
    },
    computed: {
        additionalInfo() {
            if(this.item && this.item.hasOwnProperty('additional_info') && this.item['additional_info']) {
                return this.item['additional_info'];
            }
            return null;
        }
    },
    template: `<div class="product-additional-info" v-if="additionalInfo">
        <div class="page-width">
          <div class="grid grid--1-col">
            <div class="grid__item" v-html="additionalInfo"></div>
          </div>
        </div>
      </div>`
}
const SimilarWorks = {
    props: {
        item: Object,
        contents: ''
    },
    data() {
        return {
            products: [],
            categories: {},
            total: 0,
            accessToken: null,
            stock: null,
            iterator: null,
            loading: false,
            apiFilters: {}
        }
    },
    mounted() {
        if(this.item) {
            let filters = this.cloneObject(this.xApiFilters);
            if((this.item.hasOwnProperty('entity_id') && this.item.entity_id) || this.item.shopify) {
                let words = this.item.title.toLowerCase();
                words = words.replace('wall mural','')
                words = words.replace('canvas print','')
                filters['search_parameters']['words'] = words.trim();
            } else {
                filters['search_parameters']['similar'] = Number(this.item.id);
            }
            filters['search_parameters']['limit'] = 6;
            this.apiFilters = filters;
            this.loading = true;
            this.getProducts();
        }
    },
    computed: {
        collectionHandle() {
            return (this.item.type && this.item.type !== 'mural') ? this.item.type : 'murals';
        }
    },
    methods: {
        backgroundImage(p) {
            return this.item.type === 'canvas' ? 'url('+this.previewUrl + p.thumbnail_url+')' : 'url('+p.thumbnail_url+')';
        },
        getProducts() {
            fetch(this.adobeApiSearchUrl, {method: 'POST', body: JSON.stringify(this.apiFilters), headers: this.fetchHeaders})
                .then((response) => response.json())
                .then((response) => {
                    if(response && response.files) {
                        this.products = response.files;
                        this.total = parseInt(response.nb_results);
                        if(this.item && this.item.hasOwnProperty('similar_categories') && this.item.similar_categories.length > 0) {
                            this.item.similar_categories.forEach((category) => {
                                this.categories[category.id] = {
                                    'name': category.title,
                                    'handle': category.link
                                }
                            });
                        } else {
                            this.products.forEach((product) => {
                                if(product.hasOwnProperty('category') && product.category.hasOwnProperty('name') && product.category.hasOwnProperty('id')) {
                                    if(!this.categories.hasOwnProperty(product.category.id)) {
                                        let handle = product.category.name.toLowerCase();
                                        let handles = handle.split('&gt;');
                                        handle = handles.pop();
                                        if(handle !== undefined) {
                                            handle = handle.replace(/[\W_]+/gm, '_');
                                            this.categories[product.category.id] = {
                                                'name': product.category.name,
                                                'handle': '/collections/'+this.collectionHandle+'/'+handle
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    template: `<div class="product-highlights" v-if="products.length > 0">
    <div class="inner-highlights">
        <div class="related-products-container">
          <div class="title" v-if="item.type !== 'wallpaper'">Similar Works</div>
          <div class="products-grid" v-if="item.type !== 'wallpaper'">
            <div class="slick-item item" v-for="product in products" :key="product.id">
                <div class="shop-cat-wrap"><a :href="getUrl(product,this.item.type)" class="coll-shop-img" :style="{'background-image': backgroundImage(product)}"></a></div>
            </div>
          </div>
          <div class="product-categories" v-if="Object.keys(categories).length > 0">
            <span>Similar categories:</span>
            <a v-for="(category, id) in categories" :key="id" :href="category.handle" v-html="category.name"></a>
          </div>
        </div>
     </div>
  </div>`
}
const CrossSells = {
    props: {
        item: Object
    },
    data() {
        return {
            products: [],
            accessToken: null,
            stock: null,
            iterator: null,
            loading: false,
            apiFilters: {}
        }
    },
    mounted() {
        if(this.item) {
            let filters = this.cloneObject(this.xApiFilters);
            if((this.item.hasOwnProperty('entity_id') && this.item.entity_id) || this.item.hasOwnProperty('handle')) {
                let words = this.item.title.toLowerCase();
                words = words.replace('wall mural','')
                words = words.replace('canvas print','')
                filters['search_parameters']['words'] = words;
            } else {
                filters['search_parameters']['similar'] = Number(this.item.id);
            }
            filters['search_parameters']['limit'] = 6;
            this.loading = true;
            this.apiFilters = filters;
            this.getProducts();
        }
    },
    computed: {
    },
    methods: {
        image(p,isCanvas) {
            return isCanvas ? this.previewUrl + p.thumbnail_url : p.thumbnail_url;
        },
        getProducts() {
            fetch(this.adobeApiSearchUrl, {method: 'POST', body: JSON.stringify(this.apiFilters), headers: this.fetchHeaders})
                .then((response) => response.json())
                .then((response) => {
                    if(response && response.files) {
                        this.products = response.files;
                    }
                })
                .catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.loading = false;
                });
        },
    },
    template: `<template v-if="products.length > 0">
      <div class="minicart-crosssells">
        <div class="title">{{ item.type === 'canvas' ? 'Canvases You May Also Like' : 'Murals You May Also Like' }}</div>
        <div class="items">
          <div class="item" v-for="product in products" :key="product.id">
            <a :href="getUrl(product,(item.type === 'canvas' ? 'canvas':'mural'))">
              <img :src="image(product,(item.type === 'canvas'))">
            </a>
          </div>
        </div>
      </div>
      <div class="minicart-crosssells">
        <div class="title">{{ item.type !== 'canvas' ? 'Canvases You May Also Like' : 'Murals You May Also Like' }}</div>
        <div class="items">
          <div class="item" v-for="product in products" :key="product.id">
            <a :href="getUrl(product,(item.type !== 'canvas' ? 'canvas':'mural'))">
              <img :src="image(product,(item.type !== 'canvas'))">
            </a>
          </div>
        </div>
      </div>
  </template>`
}
const materialsModalCompare = {
    props: {
        materials: Array
    },
    data() {
        return {}
    },
    emits: ['closeCompareModal','openCompareModal','openSampleModal'],
    mounted() {},
    computed: {
        showComparePopup() {
            return store.getters['modal/showComparePopup'];
        },
    },
    methods: {
        openCompareModal() {
            this.$emit('openCompareModal');
        },
        closeCompareModal() {
            this.$emit('closeCompareModal');
        },
        openSampleModal() {
            this.$emit('openSampleModal');
        }
    },
    template: `<div class="materials-modal materials-modal--compare" :class="{'open': showComparePopup}">
    <div class="modal-mask" v-if="materials.length > 0">
      <div class="modal-wrapper" @click="closeCompareModal">
        <div class="modal-container light--scrollbar" @click.stop="">
          <div class="modal-header">Compare Materials</div>
          <div class="modal-body">
            <ul class="materials-list">
                <li v-for="material in materials">
                  <div class="material-wrapper">
                    <div class="material-image d-none d-md-block">
                      <img :src="material.image" alt="" width="236" height="236">
                    </div>
                    <div class="material-details">
                      <div class="material-image d-md-none">
                        <img :src="material.image" alt="" width="140" height="140">
                      </div>
                      <div>
                        <span v-if="material.badge" class="material-badge material-badge--compare" v-text="material.badge"></span>
                      </div>
                      <div class="label" v-html="material.label"></div>
                      <p class="custom-option-description" v-html="material.description"></p>
                    </div>
                  </div>
                </li>
            </ul>
            <div class="material-help">
              <p><strong>Need help choosing a material?</strong></p>
              <p>See Our <a href="/pages/pricing" target="_blank">Material Guide</a> or <a href="/pages/contact" target="_blank">Contact Us</a></p>
            </div>
          </div>
          <button class="modal-back btn button button--back" @click.stop.prevent="closeCompareModal(); openSampleModal()">
            <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" style="transform: scaleX(-1)" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg>
            <span>Back</span>
          </button>
        </div>
      </div>
    </div>
  </div>`
}
const moduleWishlist = {
    namespaced: true,
    state () {
        return {
            items: JSON.parse(localStorage.getItem('limitlesswalls_wishlist_items')) || []
        }
    },
    mutations: {
        ADD_ITEM(state, payload) {
            const item = payload.item;
            const itemFound = state.items.findIndex(row => (
                row.id === item.id &&
                row.type === item.type
            ));
            if(itemFound === -1) {
                state.items.push(item);
                const event = new Event('wishlist:autosave');
                window.dispatchEvent(event);
            }
        },
        LOAD_ITEMS(state, payload) {
            state.items = payload.items;
        },
        REMOVE_ITEM(state, payload) {
            const item = payload.item;
            const itemFound = state.items.findIndex(row => (
                row.id === item.id &&
                row.type === item.type
            ));
            if (itemFound > -1) {
                state.items.splice(itemFound, 1);
                if(state.items.length > 0) {
                    const event = new Event('wishlist:autosave');
                    window.dispatchEvent(event);
                }
            }
        },
        CLEAR_ITEMS(state) {
            state.items = []
        },
        SAVE_ITEMS(state) {
            const parsed = JSON.stringify(state.items);
            localStorage.setItem('limitlesswalls_wishlist_items', parsed);
        }
    },
    getters: {
        items (state) {
            return state.items
        }
    },
    actions: {
        clear(wishlist) {
            wishlist.commit('CLEAR_ITEMS')
            wishlist.commit('SAVE_ITEMS')
        },
        add(wishlist, item) {
            if(item) {
                wishlist.commit('ADD_ITEM', item)
                wishlist.commit('SAVE_ITEMS')
            }
        },
        load(wishlist, items) {
            if(items) {
                wishlist.commit('LOAD_ITEMS', items)
                wishlist.commit('SAVE_ITEMS')
            }
        },
        remove(wishlist, item) {
            if(item) {
                wishlist.commit('REMOVE_ITEM', item)
                wishlist.commit('SAVE_ITEMS')
            }
        },
    }
}
const moduleModal = {
    namespaced: true,
    state () {
        return {
            show: false,
            modalBody: '',
            modalHeader: '',
            modalFooter: '',
            modalClass: '',
            showComparePopup: false, // <-- Add this line
        }
    },
    getters: {
        show(state) {
            return state.show
        },
        modalClass(state) {
            return state.modalClass
        },
        modalHeader(state) {
            return state.modalHeader
        },
        modalBody(state) {
            return state.modalBody
        },
        modalFooter(state) {
            return state.modalFooter
        },
        showComparePopup(state) {
            return state.showComparePopup;
        }
    },
    mutations: {
        OPEN(state) {
            state.show = true;
        },
        CLOSE(state) {
            state.show = false;
        },
        SET(state, payload) {
            state.modalBody = payload.modalBody;
            state.modalHeader = payload.modalHeader;
            state.modalFooter = payload.modalFooter;
            state.modalClass = payload.modalClass;
        },
        SET_COMPARE_POPUP(state, value) {
            state.showComparePopup = value;
        }
    },
    actions: {
        open(modal) {
            modal.commit('OPEN')
        },
        close(modal) {
            modal.commit('CLOSE');
            setTimeout(() => {
                document.body.classList.remove('overflow-hidden');
                document.body.style.paddingRight = '';
            },250);
        },
        set(modal, data) {
            modal.commit('SET', data)
        },
        openComparePopup(modal) {
            modal.commit('SET_COMPARE_POPUP', true);
        },
        closeComparePopup(modal) {
            modal.commit('SET_COMPARE_POPUP', false);
        }
    }
}
const moduleCartPopup = {
    namespaced: true,
    state () {
        return {
            show: false,
            error: null,
            loading: false,
            total: '',
            placeholder: false,
            requestItem: {},
            responseItem: {},
            item: {},
            fetchHeaders: new Headers({'pragma':'no-cache','cache-control':'no-store','Content-Type':'application/json'}),
            fetchHeadersApi: new Headers({'Content-Type':'application/json'}),
            cartAddUrl: '/cart/add.js',
            cartCheckUrl: 'https://direct.limitlesswalls.com/llw/Check.php',
            productCreateUrl: 'https://direct.limitlesswalls.com/llw/Create.php',
            productUpdateUrl: 'https://direct.limitlesswalls.com/llw/Update.php',
            uploadShopifyImageUrl: 'https://direct.limitlesswalls.com/llw/ShopifyUpload.php',
            cartNotification: document.querySelector('cart-notification')
        }
    },
    getters: {
        show(state) {
            return state.show
        },
        loading(state) {
            return state.loading
        },
        total(state) {
            return state.total
        },
        item(state) {
            return state.item
        },
        placeholder(state) {
            return state.placeholder
        },
        requestItem(state) {
            return state.requestItem
        },
        responseItem(state) {
            return state.responseItem
        },
        error(state) {
            return state.error
        }
    },
    mutations: {
        OPEN(state) {
            state.show = true;
        },
        CLOSE(state) {
            state.show = false;
        },
        SET(state, payload) {
            state.placeholder = payload.placeholder
            state.total = payload.total;
            state.requestItem = payload.requestItem;
            state.responseItem = payload.responseItem;
            state.item = payload.item;
        },
        SETERROR(state, payload) {
            state.error = payload.error;
        },
        STARTLOADING(state) {
            state.loading = true;
        },
        ENDLOADING(state) {
            state.loading = false;
        }
    },
    actions: {
        open(cart) {
            cart.commit('OPEN')
        },
        close(cart) {
            cart.commit('CLOSE')
        },
        set(cart, data) {
            cart.commit('SET', data)
        },
        loading(cart, data) {
            if(data.loading === true) {
                cart.commit('STARTLOADING');
            } else {
                cart.commit('ENDLOADING');
            }
        },
        buy(cart, data) {
            cart.commit('SETERROR', {'error': null});
            cart.commit('STARTLOADING');
            const body = JSON.stringify(data['cart']);
            fetch(cart.state.cartAddUrl,{method: 'POST', headers: cart.state.fetchHeaders , body})
                .then((response) => response.json())
                .then((response) => {
                    if(response.hasOwnProperty('status') && response.hasOwnProperty('description')) {
                        cart.commit('SETERROR', {'error': response.description});
                    } else {
                        const cartData = {
                            'total': response.sections['cart-total'],
                            'requestItem': data['cart'],
                            'responseItem': response.items[0],
                            'item': data['product']
                        };
                        cart.commit('SET', cartData);
                        cart.state.cartNotification.renderContents(response, cartData);
                        cart.commit('OPEN')
                    }
                })
                .catch((e) => {
                    console.error(e);
                }).finally(() => {
                    cart.commit('ENDLOADING');
                });
        },
        order(cart, data) {
            cart.commit('SETERROR', {'error': null});
            cart.commit('STARTLOADING');
            const orderPromise = new Promise((resolve, reject) => {
                if(data['croppedImage']) {
                    setTimeout(() => {
                        const placeholderData = {
                            'placeholder': true,
                            'total': null,
                            'requestItem': data['cart'],
                            'responseItem': null,
                            'item': data['product']
                        };
                        cart.commit('SET', placeholderData);
                        cart.commit('OPEN');
                    },500);
                    fetch(cart.state.uploadShopifyImageUrl, {method: 'POST', body: data['croppedImage']})
                        .then((response) => response.json())
                        .then((response) => {
                            if(response.hasOwnProperty('url')) {
                                data['form'].set('properties[_cropped_image]',response.url);
                            }
                            resolve();
                        })
                        .catch((e) => {
                            console.error(e);
                        });
                } else {
                    resolve();
                }
            }).then(() => {
                fetch(cart.state.cartAddUrl,{method: 'POST', body: data['form']})
                    .then((response) => response.json())
                    .then((response) => {
                        if(response.hasOwnProperty('status') && response.hasOwnProperty('description')) {
                            cart.commit('SETERROR', {'error': response.description});
                            return null;
                        }
                        return response;
                    })
                    .then((response) => {
                        if(response) {
                            fetch(data['sections_url'] + '?sections=' + data['sections'].join(','), {method: 'GET'})
                                .then((responseSections) => responseSections.json())
                                .then((responseSections) => {
                                    let finalResponse = Object.assign(response, {'sections': responseSections});
                                    const cartData = {
                                        'placeholder': false,
                                        'total': finalResponse.sections['cart-total'],
                                        'requestItem': data['cart'],
                                        'responseItem': finalResponse,
                                        'item': data['product']
                                    };
                                    cart.commit('SET', cartData)
                                    cart.state.cartNotification.renderContents(finalResponse, cartData);
                                    cart.commit('OPEN')
                                })
                                .catch((e) => {
                                    console.error(e);
                                })
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        cart.commit('ENDLOADING');
                    });
            });
        },
        add(cart, data) {
            const params = JSON.stringify(data);
            cart.commit('SETERROR', {'error': null});
            cart.commit('STARTLOADING');
            fetch(cart.state.cartCheckUrl,{method: 'POST', headers: cart.state.fetchHeadersApi, body: params})
                .then((response) => response.json())
                .then((response) => {
                    if(response && response.hasOwnProperty('product') && response.product.hasOwnProperty('variants') && response.product.variants.length > 0) {
                        data['cart']['items'][0]['id'] = response.product.variants[0]['id'];
                        data['cart']['items'][0]['quantity'] = 1;
                    }
                    const body = JSON.stringify(data['cart']);
                    fetch(cart.state.cartAddUrl,{method: 'POST', headers: cart.state.fetchHeaders , body})
                        .then((response) => response.json())
                        .then((response) => {
                            if(response.hasOwnProperty('status') && response.hasOwnProperty('description')) {
                                cart.commit('SETERROR', {'error': response.description});
                            } else {
                                const cartData = {
                                    'total': response.sections['cart-total'],
                                    'requestItem': data['cart'],
                                    'responseItem': response.items[0],
                                    'item': data['product']
                                };
                                cart.commit('SET', cartData);
                                cart.state.cartNotification.renderContents(response, cartData);
                                cart.commit('OPEN')
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                        }).finally(() => {
                            cart.commit('ENDLOADING');
                        });
                });
        },
        submit(cart, data) {
            cart.commit('SETERROR', {'error': null});
            cart.commit('STARTLOADING');
            setTimeout(() => {
                const placeholderData = {
                    'placeholder': true,
                    'total': null,
                    'requestItem': data['cart'],
                    'responseItem': null,
                    'item': data['product']
                };
                cart.commit('SET', placeholderData);
                cart.commit('OPEN');
            },2000);
            fetch(cart.state.productCreateUrl, {method: 'POST', body: data.additional})
                .then((response) => response.json())
                .then((response) => {
                    return new Promise((resolve, reject) => {
                        if(response && response.hasOwnProperty('product') && response.product.hasOwnProperty('variants') && response.product.variants.length > 0) {
                            data['form'].set('id',response.product.variants[0]['id']);
                            if(response.product.productType !== 'Wallpaper') {
                                data['form'].set('quantity',1);
                            }
                            setTimeout(() => {
                                resolve(response);
                            }, 1000)
                        } else {
                            resolve(response);
                        }
                    })
                })
                .then((response) => {
                    fetch(cart.state.cartAddUrl, {method: 'POST', body: data['form']})
                        .then((response) => response.json())
                        .then((response) => {
                            if(response.hasOwnProperty('status') && response.hasOwnProperty('description')) {
                                cart.commit('SETERROR', {'error': response.description});
                                return null;
                            }
                            return response;
                        })
                        .then((response) => {
                            if(response) {
                                fetch(data['sections_url'] + '?sections=' + data['sections'].join(','), {method: 'GET'})
                                    .then((responseSections) => responseSections.json())
                                    .then((responseSections) => {
                                        let finalResponse = Object.assign(response, {'sections': responseSections});
                                        const cartData = {
                                            'placeholder': false,
                                            'total': finalResponse.sections['cart-total'],
                                            'requestItem': data['cart'],
                                            'responseItem': finalResponse,
                                            'item': data['product']
                                        };
                                        cart.commit('SET', cartData)
                                        cart.state.cartNotification.renderContents(finalResponse, cartData);
                                        //cart.commit('OPEN')
                                    })
                                    .catch((e) => {
                                        console.error(e);
                                    })
                            }
                        })
                        .finally(() => {
                            cart.commit('ENDLOADING');
                        });

                });
        }
    }
}
const moduleSamplePopup = {
    namespaced: true,
    state () {
        return {
            show: false,
            item: {},
            croppedFile: null,
            files: null,
            fetchHeaders: new Headers({'pragma':'no-cache','cache-control':'no-store','Content-Type':'application/json'}),
            cartAddUrl: '/cart/add.js',
            productCreateUrl: 'https://direct.limitlesswalls.com/llw/Create.php',
            cartNotification: document.querySelector('cart-notification')
        }
    },
    getters: {
        show(state) {
            return state.show
        },
        item(state) {
            return state.item
        },
        croppedFile(state) {
            return state.croppedFile
        },
        files(state) {
            return state.files
        },
    },
    mutations: {
        OPEN(state) {
            state.show = true;
        },
        CLOSE(state) {
            state.show = false;
        },
        SET(state, payload) {
            state.item = payload.item;
            state.croppedFile = payload.croppedFile;
            state.files = payload.files;
        }
    },
    actions: {
        open(popup) {
            popup.commit('OPEN')
        },
        close(popup) {
            popup.commit('CLOSE')
        },
        set(popup, data) {
            popup.commit('SET', data)
        },
        add(popup, data) {
            fetch(popup.state.productCreateUrl, {method: 'POST', body: data.additional})
                .then((response) => response.json())
                .then((response) => {
                    return new Promise((resolve, reject) => {
                        if(response && response.hasOwnProperty('product') && response.product.hasOwnProperty('variants') && response.product.variants.length > 0) {
                            data['form'].set('id',response.product.variants[0]['id']);
                            setTimeout(() => {
                                resolve(response);
                            }, 1000)
                        } else {
                            resolve(response);
                        }
                    })
                })
                .then((response) => {
            fetch(popup.state.cartAddUrl, {method: 'POST', body: data['form']})
                .then((response) => response.json())
                .then((response) => {
                    const cartData = {
                        'responseItem': response
                    };
                    popup.state.cartNotification.createEvents(cartData);
                }).then(() => {
                    return new Promise(function(resolve, reject) {
                        setTimeout(() => {
                            resolve();
                                }, 500)
                    });
                }).then(() => {
                    window.location.href = '/cart';
                })
                .catch((e) => {
                    console.error(e);
                }).finally(() => {

            });
                })
        }
    }
}
const moduleMessages = {
    namespaced: true,
    state () {
        return {
            message: null,
            type: null
        }
    },
    getters: {
        message(state) {
            return state.message
        },
        type(state) {
            return state.type
        }
    },
    mutations: {
        SET(state, payload) {
            state.message = payload.message;
            state.type = payload.type;
        },
        CLOSE(state) {
            state.message = null;
            state.type = null;
        },
    },
    actions: {
        set(message, data) {
            message.commit('SET', data)
        },
        close(message) {
            message.commit('CLOSE')
        },
    }
}
const moduleDiscounts = {
    namespaced: true,
    state () {
        return {
            discount: null
        }
    },
    getters: {
        discount(state) {
            return state.discount
        }
    },
    mutations: {

    },
    actions: {

    }
}
const store = Vuex.createStore({
    modules: {
        wishlist: moduleWishlist,
        modal: moduleModal,
        cartPopup: moduleCartPopup,
        samplePopup: moduleSamplePopup,
        messages: moduleMessages
    }
})
const AdobeClientPlugin = {
    install(app, options) {
        const defaultUrl = '/products';
        const pushToDataLayer = (data) => {
            let timer = null;
            let count = 0;
            let dataLayer = window.dataLayer;
            timer = setInterval(() => {
                if(dataLayer) {
                    clearInterval(timer);
                    dataLayer = window.dataLayer;
                    dataLayer.push(data);
                    console.log("Data Layer"+" :"+JSON.stringify(data, null, " "));

                    if (window.gtag && data.hasOwnProperty('products') && data.products) {
                        gtag('event', 'product_view', data.products);
                    }
                } else {
                    count += 1000;
                    if (count > 9000) clearInterval(timer);
                }
            },1000);
        };
        const loadShopperApprovedAnswerBaseWidget = (data) => {
            var abWidgetsrc= "https://limitlesswalls.services.answerbase.com/javascript/widget/full-featured-widget.min.js"
            var abjs = window.document.createElement("script");
            abjs.src = abWidgetsrc;
            abjs.type = "text/javascript";
            abjs.setAttribute("data-product-external-id", data.productId);
            abjs.setAttribute("data-product-sku", data.productSku);
            abjs.setAttribute("data-product-title", data.productTitle);
            abjs.setAttribute("data-product-price", data.productPrice);
            abjs.setAttribute("data-product-url", data.productURL);
            abjs.setAttribute("data-product-description", data.productDesc);
            abjs.setAttribute("data-product-image-url", data.productImage);
            if(data.hasOwnProperty('categories') && data.categories.length > 0) {
                abjs.setAttribute("data-product-association-product-category", data.categories.join(','));
            }
            abjs.setAttribute("data-on-page-search-elements", "#shippingTab, Shipping; #canvasDetailsTab, Mural Installation");
            abjs.setAttribute("data-list-type", "relevance");
            abjs.setAttribute("data-show-content-allproducts", "true");
            abjs.setAttribute("data-insert-after", ".answerbase-widget-target");
            abjs.setAttribute("data-open-ask", "expand");
            abjs.setAttribute("defer", "");
            document.getElementsByTagName("head")[0].appendChild(abjs);

            var abCTAWidgetsrc= "https://limitlesswalls.services.answerbase.com/javascript/widget/cta-widget.min.js"
            var abCTAjs = window.document.createElement("script");
            abCTAjs.src = abCTAWidgetsrc;
            abCTAjs.type = "text/javascript";
            abCTAjs.setAttribute("data-insert-after", ".product-info .product-header");
            abCTAjs.setAttribute("defer", "");
            document.getElementsByTagName("head")[0].appendChild(abCTAjs);
        };
        const pushToKlaviyo = (item) => {
            let timer = null;
            let count = 0;
            timer = setInterval(() => {
                if(_learnq) {
                    clearInterval(timer);
                    _learnq.push(['track', 'Viewed Product', item]);
                    _learnq.push(['trackViewedItem', {
                        Title: item.Name,
                        ItemId: item.ProductID,
                        ImageUrl: item.ImageURL,
                        Url: item.URL,
                        Metadata: {
                            Brand: item.Brand,
                            Price: item.Price,
                            Type: item.ProductType
                        }
                    }]);
                    console.log("Viewed Product"+" :"+JSON.stringify(item, null, " "));
                } else {
                    count += 1000;
                    if (count > 9000) clearInterval(timer);
                }
            },1000);
        };
        const generateStarsHtml = (rating) => {
            let ratingHtml = `<span tabindex="0" aria-label="${rating}-star overall rating">`;
            let rate = parseFloat(rating);
            for (let i = 0; i < 5; i++) {
                if (rate >= 0.75) {
                    ratingHtml += `<span class="SA__star SA_activestar"> <svg id="Star" xmlns="http://www.w3.org/2000/svg" width="26.287" height="25" viewBox="0 0 26.287 25"> <path id="Path_2712" data-name="Path 2712" d="M220.363-1546.716l3.1,9.549h10.041l-8.123,5.9,3.1,9.549-8.123-5.9-8.123,5.9,3.1-9.549-8.123-5.9h10.041Z" transform="translate(-207.22 1546.716)" fill="#EB7100"/> </svg> </span>`
                } else if (rate >= 0.24) {
                    ratingHtml += `<span class="SA__star SA_activestar"> <svg id="Star-Half" xmlns="http://www.w3.org/2000/svg" width="26.261" height="25" viewBox="0 0 26.261 25"> <path id="Path_3144" data-name="Path 3144" d="M13.5,0l3.1,9.55h10l-8.12,5.9L21.62,25,13.5,19.1,5.38,25l3.1-9.55L.35,9.55h10Z" transform="translate(-0.35)" fill="none"/> <path id="Path_3145" data-name="Path 3145" d="M13.5,4.85V17.24l.89.64,4.38,3.19L17.1,15.91l-.34-1,.88-.64L22,11.05H15.52l-.34-1L13.5,4.85M13.5,0l3.11,9.55h10l-8.13,5.9L21.63,25,13.5,19.1,5.38,25l3.1-9.55L.36,9.55h10Z" transform="translate(-0.35)" fill="#EB7100"/> </svg> </span>`
                } else {
                    ratingHtml += `<span class="SA__star empty SA_activestar"> <svg id="Star_Empty" data-name="Star Empty" xmlns="http://www.w3.org/2000/svg" width="26.287" height="25" viewBox="0 0 26.287 25"> <g id="Path_2712" data-name="Path 2712" transform="translate(-207.22 1546.716)" fill="none"> <path d="M220.363-1546.716l3.1,9.549h10.041l-8.123,5.9,3.1,9.549-8.123-5.9-8.123,5.9,3.1-9.549-8.123-5.9h10.041Z" stroke="none"/> <path d="M 220.3634185791016 -1541.861938476563 L 218.6873168945313 -1536.703369140625 L 218.3505554199219 -1535.666870117188 L 217.2607269287109 -1535.666870117188 L 211.8366394042969 -1535.666870117188 L 216.2248229980469 -1532.478637695313 L 217.1064910888672 -1531.838134765625 L 216.7697143554688 -1530.801635742188 L 215.0935974121094 -1525.64306640625 L 219.4817504882813 -1528.831176757813 L 220.3634185791016 -1529.471801757813 L 221.2450866699219 -1528.831176757813 L 225.6332550048828 -1525.64306640625 L 223.9571228027344 -1530.801635742188 L 223.6203460693359 -1531.838134765625 L 224.5020294189453 -1532.478637695313 L 228.8902130126953 -1535.666870117188 L 223.4661254882813 -1535.666870117188 L 222.3763122558594 -1535.666870117188 L 222.0395355224609 -1536.703369140625 L 220.3634185791016 -1541.861938476563 M 220.3634185791016 -1546.716064453125 L 223.4661254882813 -1537.166870117188 L 233.5066986083984 -1537.166870117188 L 225.3837127685547 -1531.26513671875 L 228.4864044189453 -1521.716064453125 L 220.3634185791016 -1527.61767578125 L 212.2404327392578 -1521.716064453125 L 215.3431396484375 -1531.26513671875 L 207.2201385498047 -1537.166870117188 L 217.2607269287109 -1537.166870117188 L 220.3634185791016 -1546.716064453125 Z" stroke="none" fill="#EB7100"/> </g> </svg> </span>`
                }
                rate--
            }
            ratingHtml += `</span>`;
            return ratingHtml
        };
        const injectShopperApprovedReveiews = () => {
            return new Promise((resolve, reject) => {
                const saUrl = 'https://api.shopperapproved.com/aggregates/reviews/17195?token=xhK2VTbrtz7wZXM&xml=false';
                fetch(saUrl, {method: 'GET'})
                    .then((response) => response.json())
                    .then((response) => {
                        if(response && response.hasOwnProperty('total_reviews') && response.hasOwnProperty('average_rating')) {
                            const saReviews = response.total_reviews;
                            const saRating = response.average_rating;
                            const saRatingStarsHtml = generateStarsHtml(saRating);
                            const saRatingHtml = `<a href="#product-reviews-anchor">${saRatingStarsHtml} ${Number(saReviews).toLocaleString()} reviews</a>`;
                            document.querySelectorAll('.product-reviews-summary').forEach((el) => {
                                el.innerHTML = saRatingHtml;
                            });
                            resolve(response);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            });
        };
        app.config.globalProperties.remoteApiUrl = window.remoteApiUrl;
        app.config.globalProperties.remoteWishlistUrl = window.remoteWishlistUrl;
        app.config.globalProperties.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        app.config.globalProperties.fetchCollectionUrl = window.remoteApiUrl + 'llw/Load.php';
        app.config.globalProperties.adobeApiSearchUrl = window.remoteApiUrl + 'llw/Search.php';
        app.config.globalProperties.adobeApiMetadataUrl = window.remoteApiUrl + 'llw/Metadata.php';
        app.config.globalProperties.graphqlUrl = window.graphqlUrl;
        app.config.globalProperties.storefrontToken = window.storefrontToken;
        app.config.globalProperties.fetchHeaders = new Headers({'Content-Type':'application/json'});
        app.config.globalProperties.xApiFilters = {
            'locale': 'en-US',
            'search_parameters': {
                thumbnail_size: 240,
                filters_content_type_photo: 1,
                filters_image_width: 4200,
                filters_gentech: 'false',
                filters_premium: 'false'
            }
        };
        app.config.globalProperties.cartAddUrl = '/cart/add.js';
        app.config.globalProperties.previewUrl = 'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos/?frame=canvas2&style=style1&size=600&url=';
        app.config.globalProperties.canvasUrls = {
            'small': [
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall1&style=small&size=1000&check=false&url=',
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall2&style=small&size=1000&check=false&url='
            ],
            'medium': [
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall1&style=medium&size=1000&check=false&url=',
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall2&style=medium&size=1000&check=false&url='
            ],
            'large': [
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall1&style=large&size=1000&check=false&url=',
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall2&style=large&size=1000&check=false&url='
            ],
            'xl': [
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall1&style=xl&size=1000&check=false&url=',
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall2&style=xl&size=1000&check=false&url='
            ],
            'xxl': [
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall1&style=xxl&size=1000&check=false&url=',
                'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos?frame=wall2&style=xxl&size=1000&check=false&url='
            ]
        };
        app.config.globalProperties.muralDMI = window.muralDMI;
        app.config.globalProperties.apiMuralDMI = window.apiMuralDMI;
        app.config.globalProperties.decodeEntity = (input) => {
            let textarea = document.createElement("textarea");
            textarea.innerHTML = input;
            return textarea.value;
        };
        app.config.globalProperties.cloneObject = (o) => {
            return JSON.parse(JSON.stringify(o));
        }
        app.config.globalProperties.formatCurrency = (amount) => {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(amount/100);
        };
        app.config.globalProperties.capitalize = (text) => {
            return text.toLowerCase()
                .split(' ')
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ');
        };
        app.config.globalProperties.getAspectRatio = (width, height) => {
            let ratio = null;
            const ratios = [0.33, 0.67, 1, 1.5, 3];
            const realRatio = width / height;
            ratios.forEach((item) => {
                if(ratio === null ||  Math.abs(realRatio - ratio) > Math.abs(item - realRatio)) {
                    ratio = item;
                }
            })
            return '' + ratio;
        };
        app.config.globalProperties.errorMessage = (message) => {
            return `<ul class="messages"><li class="error-msg"><span>${message}</span></li></ul>`
        };
        app.config.globalProperties.successMessage = (message) => {
            return `<ul class="messages"><li class="success-msg"><span>${message}</span></li></ul>`
        };
        app.config.globalProperties.updateDataLayer = (data) => {
            pushToDataLayer(data);
        };
        app.config.globalProperties.getItemImage = (properties) => {
            let img = null;
            if(properties) {
                if(properties.hasOwnProperty('_cropped_image') && properties['_cropped_image']) {
                    img = properties['_cropped_image'];
                } else if(properties.hasOwnProperty('_canvas_image') && properties['_canvas_image']) {
                    img = properties['_canvas_image'];
                } else if(properties.hasOwnProperty('_original_image') && properties['_original_image']) {
                    img = properties['_original_image'];
                }
            }
            return img;
        };
        app.config.globalProperties.updateMetas = (product, isStatic) => {
            // Fixed Price products
            isStatic = (typeof isStatic === 'undefined') ? false : isStatic;
            if(isStatic) {
                return;
            }
            const productUrl = window.location.href.split('?')[0];
            let productImage = product.hasOwnProperty('dmi') && product.dmi ? product.dmi : product.url;
            productImage = productImage.replace('http:', 'https:');
            let meta_description = '';
            if(product.hasOwnProperty('meta_description') && product.meta_description) {
                meta_description = product.meta_description;
            } else if(product.hasOwnProperty('description') && product.description) {
                meta_description = product.description;
            } else {
                meta_description = product.title;
            }
            if(!isStatic) {
                if(product.meta_title) {
                    document.querySelector('title').innerText = product.title;
                } else if(product.title) {
                    document.querySelector('title').innerText = product.title;
                }

                if(meta_description !== '') {
                    let metaTag = document.querySelector('meta[name="description"]');
                    if(metaTag) {
                        metaTag.setAttribute("content", meta_description);
                    } else {
                        let metaTag = document.createElement('meta');
                        metaTag.name = "description";
                        metaTag.content = meta_description;
                        document.head.appendChild(metaTag);
                    }
                }

                const ogType = document.querySelector('meta[property="og:type"]');
                if(ogType) {
                    if(meta_description !== '') {
                        let ogDescriptionMeta = document.createElement('meta');
                        ogDescriptionMeta.setAttribute('property', 'og:description');
                        ogDescriptionMeta.content = meta_description;
                        ogType.after(ogDescriptionMeta);
                    }

                    let ogTitleMeta = document.createElement('meta');
                    ogTitleMeta.setAttribute('property', 'og:title');
                    ogTitleMeta.content = product.title;
                    ogType.after(ogTitleMeta);

                    let ogImageMeta = document.createElement('meta');
                    ogImageMeta.setAttribute('property', 'og:image');
                    ogImageMeta.content = productImage;
                    ogType.after(ogImageMeta);
                }
            }

            injectShopperApprovedReveiews().then((response) => {
                try {
                    // Insert canonical on product pages

                    let link = document.querySelector('link[rel="canonical"]');
                    if(!link) {
                        let link = document.createElement('link');
                        link.setAttribute('rel', 'canonical');
                        link.href = productUrl;
                        document.head.appendChild(link);
                    } else {
                        link.setAttribute('href', productUrl);
                    }

                    const schema = {
                        "@context": "http://schema.org/",
                        "@type": "Product",
                        "name": product.title,
                        "image": isStatic ? product.featured_image : productImage,
                        "url": productUrl,
                        "description": meta_description,
                        "brand": {
                            "@type": "Thing",
                            "name": "Limitless Walls"
                        },
                        "aggregateRating": {
                            "@type": "AggregateRating",
                            "ratingValue": response.average_rating,
                            "bestRating": 5,
                            "ratingCount": response.total_reviews
                        },
                        "offers": [
                            {
                                "@type": "Offer",
                                "availability": "http://schema.org/InStock",
                                "price": Number(document.getElementById('hidden_product_price').value),
                                "priceCurrency": "USD",
                                "url": productUrl
                            }
                        ]
                    };

                    const script = document.createElement('script');
                    script.setAttribute('type', 'application/ld+json');
                    script.textContent = JSON.stringify(schema);
                    document.head.appendChild(script);

                    const productData = {
                        'productId': product.id,
                        'productSku': product.id,
                        'productTitle': product.title,
                        'productPrice': document.getElementById('hidden_product_price').value,
                        'productURL': productUrl,
                        'productDesc': meta_description,
                        'productImage': isStatic ? product.featured_image : product.url,
                        'categories': product.hasOwnProperty('similar_categories') && product.similar_categories.length > 0 ? product.similar_categories.map((c) => c.id) : []
                    };
                    loadShopperApprovedAnswerBaseWidget(productData);
                } catch (e) {
                    console.error(e);
                }
            });

            setTimeout(() => {
                try {
                const productData = {
                    'pageType': 'Product',
                    'event': 'Product',
                    'products': [{
                        'id': product.id,
                        'sku': product.id,
                        'productType': product.type,
                        'name': product.title,
                        'price': document.getElementById('hidden_product_price').value,
                        'imageURL': isStatic ? product.featured_image : product.url,
                        'productURL': productUrl
                    }]
                };
                pushToDataLayer(productData);
                } catch (e) {
                    console.error(e);
                }
                try {
                    const klaviyoItem = {
                        Name: product.title,
                        ProductID: product.id || 'custom',
                        ImageURL: isStatic ? product.featured_image : product.url,
                        URL: productUrl,
                        ProductType: product.type,
                        Brand: "Limitless Walls",
                        Price: "$"+document.getElementById('hidden_product_price').value
                    };
                    pushToKlaviyo(klaviyoItem);
                } catch (e) {
                    console.error(e);
                }
            },2000);
        };
        app.config.globalProperties.getProductUrl = (product) => {
            let url = null;
            const type = product.product_type ? product.product_type.toLowerCase() : null;
            if(product.hasOwnProperty('shopify') && product.shopify) {
                url = '/products/' + product.url;
                return url;
            } else if(product.hasOwnProperty('url_key') && product.url_key !== null) {
                url = product.url_key;
            } else if(product.hasOwnProperty('custom') && product.custom === true) {
                url = 'custom';
            } else if(product.hasOwnProperty('id') && product.id !== null) {
                url = product.id;
            }
            if(url && type) {
                if(type === 'sample') {
                    url = '/products/mural/' + url;
                } else {
                    url = '/products/' + type + '/' + url;
                }
            }
            return url;
        }
        app.config.globalProperties.getUrl = (product,type) => {
            let url = `${defaultUrl}/${type}/${product.id}`;

            if(product.hasOwnProperty('entity_id') && product.entity_id) {
                url = `${defaultUrl}/${type}/${product.url_key}`;
            } else if(product.hasOwnProperty('shopify') && product.shopify) {
                url = '/products/' + product.handle;
            } else {
                try {
                    const thumbnail_url = product.hasOwnProperty('thumbnail_url') ? btoa(product.thumbnail_url) : btoa(product.url);
                    const title = btoa(product.title)
                    url = `${defaultUrl}/${type}/${product.id}?image=${thumbnail_url}&title=${title}`;
                    if(window.collectionName) {
                        const category = btoa(window.collectionName)
                        url += `&category=${category}`;
                    }
                    if(!product.entity_id) {
                        url += '&updateImage=true';
                    }
                } catch (e) {

                }
            }

            return url;
        }
        app.config.globalProperties.observePdp = () => {
            let breakpoint = window.matchMedia('(min-width:768px)');
            const pdpBreakpointCheck = () => {
                if (breakpoint && breakpoint.matches === true ) {
                    let timer = null;
                    let count = 0;
                    timer = setInterval(() => {
                        let $sezzle = document.querySelector('.product-header .sezzle-shopify-info-button');
                        if($sezzle) {
                            clearInterval(timer);
                            document.querySelector('.product-info .price-box').appendChild($sezzle);
                        } else if(document.querySelector('.product-info .sezzle-shopify-info-button')) {
                            $sezzle = document.querySelector('.product-info .sezzle-shopify-info-button');
                            document.querySelector('.product-info .price-box').appendChild($sezzle);
                        } else {
                            count += 1000;
                            if (count > 5000) clearInterval(timer);
                        }
                    },1000);

                    let gtaTimer = null;
                    let gtaCount = 0;
                    gtaTimer = setInterval(() => {
                        const $gta = document.querySelector('.product-section .gta-widget');
                        const $check = document.querySelector('.product-info .gta-widget');
                        let $parentEl = document.querySelector('.product-info .price-wrapper');
                        if($gta && $parentEl && !$check) {
                            clearInterval(gtaTimer);
                            $parentEl.parentNode.insertBefore($gta, $parentEl);
                        } else {
                            gtaCount += 1000;
                            if (gtaCount > 10000) clearInterval(gtaTimer);
                        }
                    },1000);
                } else if (breakpoint.matches === false) {
                    let timer = null;
                    let count = 0;
                    timer = setInterval(() => {
                        const $sezzle = document.querySelector('.product-info .sezzle-shopify-info-button');
                        if($sezzle) {
                            clearInterval(timer);
                            document.querySelector('.product-header .price-box').appendChild($sezzle);
                        } else {
                            count += 1000;
                            if (count > 5000) clearInterval(timer);
                        }

                    },1000);

                    let gtaTimer = null;
                    let gtaCount = 0;
                    gtaTimer = setInterval(() => {
                        const $gta = document.querySelector('.product-section .gta-widget');
                        const $check = document.querySelector('.product-info .gta-widget');
                        let $parentEl = document.querySelector('.product-info .price-wrapper');
                        if($gta && $parentEl && !$check) {
                            clearInterval(gtaTimer);
                            $parentEl.parentNode.insertBefore($gta, $parentEl);
                        } else {
                            gtaCount += 1000;
                            if (gtaCount > 10000) clearInterval(gtaTimer);
                        }
                    },1000);
                }
            }
            breakpoint.addListener(pdpBreakpointCheck.bind(this));
            pdpBreakpointCheck();
        }
        app.config.globalProperties.validateStopWords = (product, response) => {
            return new Promise((resolve, reject) => {
                limitlessPreloadStopWordsMeta()
                    .then((stopWords) => {
                        if(stopWords && stopWords.length > 0) {
                            if(containsStopWords(product.title, stopWords)) {
                                resolve(false);
                            }
                        }
                    }).finally(() => {
                        resolve(response);
                    });
            });
        };
        app.config.globalProperties.sanitizeTextContent = (el) => {
            return el.textContent.replace(/[\u0000-\u0019]+/g, '');
        };
    }
}
const pageErrorsEl = document.getElementById('pageMessages');
const globalErrorsApp = Vue.createApp({
    template: `<ul class="messages" v-if="message"><li :class="{'error-msg':type === 'error','success-msg':type === 'success'}"><ul><li><span>{{message}}</span></li></ul></li></ul>`,
    computed: {
        type() {
            return store.getters['messages/type'];
        },
        message() {
            return store.getters['messages/message'];
        },
    },
    methods: {
        close() {
            store.dispatch('messages/close')
        },
    }
})
globalErrorsApp.use(store);
if(pageErrorsEl) {
    globalErrorsApp.mount('#pageMessages');
}
const appCookies = Cookies.noConflict();
function containsStopWords(productName, stopPhrases) {
    return stopPhrases.some(phrase => {
        const regex = new RegExp(`\\b${phrase.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}\\b`, 'i');
        return regex.test(productName);
    });
}
function limitlessPreloadStopWordsMeta() {
    return new Promise((resolve, reject) => {
        let storedStopWords = [];
        const myHeaders = new Headers();
        myHeaders.append("X-Shopify-Storefront-Access-Token", window.storefrontToken);
        myHeaders.append("Content-Type", "application/json");

        const graphql = JSON.stringify({
            query: "query { metaobjects(type: \"stop_words\", first: 250) { edges { node { id type handle fields { key value } } } } }",
            variables: {}
        })
        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: graphql,
            redirect: "follow"
        };

        fetch(window.graphqlUrl, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if(result.hasOwnProperty('data')
                    && result.data
                    && result.data.hasOwnProperty('metaobjects')
                    && result.data.metaobjects
                    && result.data.metaobjects.hasOwnProperty('edges')
                    && result.data.metaobjects.edges.length > 0
                ) {
                    result.data.metaobjects.edges.forEach((edge) => {
                        storedStopWords.push(edge.node.fields.find((f) => f.key === 'word')['value']);
                    });
                }
            })
            .catch((error) => console.error(error))
            .finally(() => {
                resolve(storedStopWords);
            });
    });
}
function limitlessCreateSlugAdvanced(text) {
    return text
        .normalize("NFD") // Normalize diacritics
        .replace(/[\u0300-\u036f]/g, '') // Remove diacritic marks
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
}
